import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const googleRedirectUri = () => window.location.origin + "/yonetim/google/baglan";

export default function GoogleCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [msg, setMsg] = useState("Google bağlantısı tamamlanıyor...");

  useEffect(() => {
    const code = params.get("code"), state = params.get("state"), err = params.get("error");
    if (err) { setMsg(`Google izni verilmedi (${err}).`); return; }
    if (!code || !state) { setMsg("Geçersiz bağlantı yanıtı."); return; }
    api.post("/admin/google/callback", { code, state })
      .then((r) => navigate(r.data.kind === "mail" ? "/yonetim/teklifler?mail=1" : "/yonetim/search-console?baglandi=1", { replace: true }))
      .catch((e) => setMsg(formatApiError(e.response?.data?.detail)));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <div className="p-8 text-slate-600" data-testid="google-callback-msg">{msg}</div>;
}
